<template>
    <div>
        <b-row v-if="unread_messages > 0">
            <b-col>
                <div class="alert alert-danger message-banner" @click="openMessages()">
                    You have <strong>{{ unread_messages }}</strong> unread messages, click here to view
                </div>
            </b-col>
        </b-row>
        <b-row>
            <b-col lg="6"> <!-- LEFT SIDE -->
                <b-card> <!-- AVERAGE SHIFT DURATION -->
                    <div v-if="! loaded" class="text-center">
                        <i class="fa fa-spinner fa-spin fa-3x fa-fw"></i>
                        <p>Loading Results...</p>
                    </div>
                    <div v-else>
                        <div class="d-flex flex-wrap">
                            <div>
                                <h3 class="card-title">Average Shift Duration</h3>
                                <h6 class="card-subtitle">Last 3 Months</h6>
                            </div>
                            <div class="ml-auto">
                                <ul class="list-inline">
                                    <li>
                                        <h6 class="text-muted text-success">
                                            <i class="fa fa-circle font-10 m-r-10 "></i>Duration
                                        </h6>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div id="shift_duration"></div>
                    </div>
                </b-card>
                <b-card> <!-- CARRIER STATS -->
                    <div v-if="! loaded" class="text-center">
                        <i class="fa fa-spinner fa-spin fa-3x fa-fw"></i>
                        <p>Loading Results...</p>
                    </div>
                    <div v-else>
                        <div class="d-flex flex-wrap">
                            <div>
                                <h3 class="card-title">Carrier Statistics</h3>
                                <h6 class="card-subtitle">Claimants &amp; Shifts Per Carrier (All time)</h6>
                            </div>
                            <div class="ml-auto">
                                <ul class="list-inline">
                                    <li>
                                        <h6 class="text-muted text-success">
                                            <i class="fa fa-circle font-10 m-r-10 "></i>Claimants
                                        </h6>
                                    </li>
                                    <li>
                                        <h6 class="text-muted  text-info">
                                            <i class="fa fa-circle font-10 m-r-10"></i>Shifts
                                        </h6>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div id="carrier_stats"></div>
                    </div>
                </b-card>

                <b-card bg-variant="green" text-variant="white">
                    <h3 class="card-title text-white">Claims Submitted</h3>
                    <div class="d-flex ml-3 mr-3 mt-3 mb-1">
                        <div class="f-1">
                            <h3 class="text-white">{{ thousandsFormat(enrollment_summary.totals ? enrollment_summary.totals.claims : 0) }}</h3>
                        </div>
                        <div class="ml-auto">
                            <i class="fa fa-check fa-2x"></i>
                        </div>
                    </div>
                </b-card>
                <b-card bg-variant="success" text-variant="white">
                    <h3 class="card-title text-white">Shifts Awaiting Approval</h3>
                    <div class="d-flex ml-3 mr-3 mt-3 mb-2">
                        <div class="f-1">
                            <h3 class="text-white">{{ thousandsFormat(shift_stats.pending) }}</h3>
                        </div>
                        <div class="ml-auto">
                            <i class="fa fa-clock-o fa-2x"></i>
                        </div>
                    </div>
                </b-card>
            </b-col>  <!-- /end LEFT SIDE -->

            <b-col lg="6">  <!-- RIGHT SIDE -->
                <b-card title="Independent Providers Currently Checked In">
                    <div v-if="! loaded" class="text-center">
                        <i class="fa fa-spinner fa-spin fa-3x fa-fw"></i>
                        <p>Loading Results...</p>
                    </div>
                    <table v-else class="table table-striped">
                        <thead>
                            <tr>
                                <th slot-scope="col">Name</th>
                                <th slot-scope="col">Type</th>
                                <th slot-scope="col">Location</th>
                                <th slot-scope="col">Duration</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for=" ( item, key ) in clocked_in_providers " :key=" 'cg' + item.caregiver_id + key ">

                                <th slot-scope="row"><a :href="`/business/caregivers/${item.caregiver_id}`">{{ item.caregiver_name }}</a></th>
                                <td>{{ item.evv_type }}</td>
                                <td>{{ item.location }}</td>
                                <td>{{ item.duration }}</td>
                            </tr>
                            <tr v-if="clocked_in_providers.length == 0" class="b-table-empty-row">
                                <td colspan="4">
                                    <div role="alert" aria-live="polite">
                                        <div class="text-center my-2">There are no records to show</div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </b-card>

                <b-card>
                    <div class="d-flex flex-wrap">
                        <div>
                            <h3 class="card-title">Enrollment Status</h3>
                            <h6 class="card-subtitle">{{ `As of: ${today}` }}</h6>
                        </div>
                        <div class="ml-auto">
                            <carrier-parents-dropdown v-model="parent_carrier"></carrier-parents-dropdown>
                        </div>
                        <div class="ml-auto">
                            <carrier-dropdown v-model="carrier"></carrier-dropdown>
                        </div>


                    </div>

                    <div v-if="! enrollmentLoaded" class="text-center">
                        <i class="fa fa-spinner fa-spin fa-3x fa-fw"></i>
                        <p>Loading Results...</p>
                    </div>
                    <div v-else>
                        <!-- <div class="form-inline mb-3">
                            <label for="datepicker" class="mr-2">As Of:</label>
                            <date-picker
                                id="datepicker"
                                v-model="dateFilter"
                                placeholder="Select Date"
                                @input="fetchEnrollmentSummary()"
                            />
                        </div> -->
                        <table class="table table-striped table-bordered">
                            <thead>
                                <th></th>
                                <th>Claimants</th>
                                <th>Providers</th>
                                <th>Total</th>
                            </thead>
                            <tbody>
                            <tr>
                                <td>Not Enrolled</td>
                                <td><a :href="getReportUrl('unenrolled', 'client')">{{ enrollment_summary.clients.not_enrolled }}</a></td>
                                <td><a :href="getReportUrl('unenrolled', 'caregiver')">{{ enrollment_summary.caregivers.not_enrolled }}</a></td>
                                <td><a :href="getReportUrl('unenrolled')">{{ enrollment_summary.clients.not_enrolled + enrollment_summary.caregivers.not_enrolled }}</a></td>
                            </tr>
                            <tr>
                                <td style="padding-left: 20px;">Material Not Sent</td>
                                <td><a :href="getReportUrl('material_not_sent', 'client')">{{ enrollment_summary.clients.material_not_sent }}</a></td>
                                <td><a :href="getReportUrl('material_not_sent', 'caregiver')">{{ enrollment_summary.caregivers.material_not_sent }}</a></td>
                                <td><a :href="getReportUrl('material_not_sent')">{{ enrollment_summary.clients.material_not_sent + enrollment_summary.caregivers.material_not_sent }}</a></td>
                            </tr>
                            <tr>
                                <td style="padding-left: 20px;">Material Sent</td>
                                <td><a :href="getReportUrl('sent_agreement', 'client')">{{ enrollment_summary.clients.sent_agreement }}</a></td>
                                <td><a :href="getReportUrl('sent_agreement', 'caregiver')">{{ enrollment_summary.caregivers.sent_agreement }}</a></td>
                                <td><a :href="getReportUrl('sent_agreement')">{{ enrollment_summary.clients.sent_agreement + enrollment_summary.caregivers.sent_agreement }}</a></td>
                            </tr>
                            <tr>
                                <td style="padding-left: 20px;">Incomplete</td>
                                <td><a :href="getReportUrl('incomplete', 'client')">{{ enrollment_summary.clients.incomplete }}</a></td>
                                <td><a :href="getReportUrl('incomplete', 'caregiver')">{{ enrollment_summary.caregivers.incomplete }}</a></td>
                                <td><a :href="getReportUrl('incomplete')">{{ enrollment_summary.clients.incomplete + enrollment_summary.caregivers.incomplete }}</a></td>
                            </tr>
                            <tr>
                                <td>Enrolled</td>
                                <td><a :href="getReportUrl('enrolled', 'client')">{{ enrollment_summary.clients.enrolled }}</a></td>
                                <td><a :href="getReportUrl('enrolled', 'caregiver')">{{ enrollment_summary.caregivers.enrolled }}</a></td>
                                <td><a :href="getReportUrl('enrolled')">{{ enrollment_summary.clients.enrolled + enrollment_summary.caregivers.enrolled }}</a></td>
                            </tr>
                            <tr>
                                <td>Total Enrolled &amp; Not Enrolled</td>
                                <td><a :href="getReportUrl('', 'client')">{{ enrollment_summary.clients.total }}</a></td>
                                <td><a :href="getReportUrl('', 'caregiver')">{{ enrollment_summary.caregivers.total }}</a></td>
                                <td><a :href="getReportUrl('')">{{ enrollment_summary.clients.total + enrollment_summary.caregivers.total }}</a></td>
                            </tr>
                            </tbody>
                        </table>

                        <table class="table table-striped table-bordered">
                            <tbody>
                                <tr>
                                    <td>Total Providers</td>
                                    <td>{{ thousandsFormat(enrollment_summary.caregivers.total) }}</td>
                                </tr>
                                <tr>
                                    <td>Total Enrolled Providers to Clients</td>
                                    <td><a :href="getPairedUrl('enrolled')">{{ thousandsFormat(enrollment_summary.pairs.enrolled) }}</a></td>
                                </tr>
                                <tr>
                                    <td>Total Providers with Visits</td>
                                    <td><a :href="getPairedUrl('enrolled')">{{ thousandsFormat(enrollment_summary.pairs.visits) }}</a></td>
                                </tr>
                                <tr>
                                    <td>Total Unpaired</td>
                                    <td><a :href="getPairedUrl('unmatched')">{{ thousandsFormat(enrollment_summary.pairs.unpaired) }}</a></td>
                                </tr>
                            </tbody>
                        </table>

                        <table class="table table-striped table-bordered">
                            <tbody>
                            <tr>
                                <td>Total Visits</td>
                                <td>{{ thousandsFormat(enrollment_summary.totals.visits) }}</td>
                            </tr>
                            <tr>
                                <td>Total Claims (Invoices excl. Revisions)</td>
                                <td>{{ thousandsFormat(enrollment_summary.totals.claims) }}</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import FormatsNumbers from '../../mixins/FormatsNumbers';

export default {
    mixins: [FormatsNumbers],

    props: ['enrollmentReportUrl', 'pairedReportUrl'],

    data() {
        return {
            enrollment_summary: {
                clients: {},
                caregivers: {},
                pairs: {},
            },
            clocked_in_providers: [],
            carrier_stats: {carriers: [], clients_count: [], shifts_count: []},
            shift_duration_report: {months: [], durations: []},
            shift_stats: {submitted: 0, pending: 0},
            loaded: false,
            enrollmentLoaded: false,
            dateFilter: null,
            unread_messages: 0,
            carrier: '',
            carriers: [],
            parent_carrier: '',
        }
    },

    computed: {
        today() {
            return moment(new Date()).format('MM/DD/YYYY')
        },
    },

    methods: {
        fetch() {
            this.enrollmentLoaded = false;
            axios.get(`/business/dashboard/data?carrier=${this.carrier}&parent_carrier_id=${this.parent_carrier}`)
                .then( ({ data }) => {
                    this.enrollment_summary = data.enrollment_summary;
                    this.clocked_in_providers = data.clocked_in_providers;
                    this.shift_duration_report = data.shift_duration_report;
                    this.carrier_stats = data.carrier_stats;
                    this.shift_stats = data.shift_stats;
                    this.unread_messages = data.unread_messages;
                    this.carriers = data.carriers;
                    this.enrollmentLoaded = true;

                    this.$nextTick().then(() => {
                        this.drawCharts();
                    });
                });
        },


        drawCharts() {
            var data = {
                labels: this.carrier_stats.carriers,
                series: [
                    this.carrier_stats.clients_count,
                    this.carrier_stats.shifts_count,
                ]
            };

            var responsiveOptions = [
                ['screen and (max-width: 640px)', {
                    seriesBarDistance: 5,
                    axisX: {
                        labelInterpolationFnc: function (value) {
                            return value[0];
                        }
                    }
                }]
            ];

            var options = {
                seriesBarDistance: 10
            };

            new Chartist.Bar('#carrier_stats', data, options, responsiveOptions);

            new Chartist.Line('#shift_duration', {
                labels: this.shift_duration_report.months,
                series: [this.shift_duration_report.durations],
            }, {
                fullWidth: true,
                chartPadding: {
                    right: 40
                }
            });
        },

        openMessages() {
            window.location = "/business/messages";
        },

        getReportUrl(status, roleType='') {
            return this.enrollmentReportUrl + '?enrollment_status=' + status + '&role_type=' + roleType;
        },

        getPairedUrl(type='unmatched') {
            return this.pairedReportUrl + '?type=' + type;
        },
    },

    async mounted() {
        this.loaded = false;
        await this.fetch();
        this.loaded = true;
    },

    watch: {
        carrier(newVal) {
            if (newVal) {
                this.parent_carrier='';
            }
            this.fetch();
        },

        parent_carrier(newVal) {
            if (newVal) {
                this.carrier='';
            }
            this.fetch();
        }
    },
}
</script>

<style scoped>
.bg-green {
    background-color: #74e174;
}
.message-banner {
    cursor: pointer;
}
.message-banner:hover {
    background-color: #fbe9e9;
}
</style>
